import { DataLake } from "@graylog/enterprise-api";
const fetchDataLakeStreams = ({ page, perPage, query }) => DataLake.getDataLakeStreams(query || void 0, page, perPage, "stream_id", "asc");
export default fetchDataLakeStreams;
